import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { PiArrowUpRight, PiArrowDownRight } from "react-icons/pi";
import { MdImageNotSupported } from "react-icons/md";
import { API_BASE } from "../../../utils/api";
import styles from "./CreatorDashboardListing.module.css";

import { useNavigate } from "react-router-dom";

const CreatorDashboardListing = ({ name, descriptor, subtitle, img, nrOwners, prChange, price }) => {
  const isPositiveChange = prChange >= 0;
  const formattedOwners = nrOwners > 1000 ? `${(nrOwners / 1000).toFixed(1)}k` : nrOwners;
  const formattedPrice = `$${price.toFixed(2)}`;

  const [imgError, setImgError] = useState(false);
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate(`/dashboard/memory/${descriptor}`);
  };

  return (
    <Box className={styles.listing}>
      {!img || imgError ? (
        <Box className={styles.fallbackImageBox} onClick={handleNavigate}>
          <MdImageNotSupported className={styles.fallbackIcon} />
        </Box>
      ) : (
        <img
          className={styles.image}
          src={`${API_BASE}${img}`}
          alt={name}
          onError={() => setImgError(true)}
          onClick={handleNavigate}
        />
      )}

      <Box className={styles.details} onClick={handleNavigate}>
        <Typography className={styles.name}>{name}</Typography>
        <Typography className={styles.subtitle}>{subtitle}</Typography>
      </Box>

      <Box className={styles.price}>
        <Typography className={styles.label}>Price</Typography>
        <Typography className={styles.semibold}>{formattedPrice}</Typography>
      </Box>

      <Box className={styles.owners}>
        <Typography className={styles.label}>Owners</Typography>
        <Typography className={styles.bold}>{formattedOwners}</Typography>
      </Box>

      <Box className={styles.change}>
        <Typography className={styles.label}>Change</Typography>
        <Box className={styles.changeArrowContainer}>
          <Typography className={`${isPositiveChange ? styles.positive : styles.negative} ${styles.bold}`} >
            {isPositiveChange ? `+${prChange}%` : `${prChange}%`}
          </Typography>
          {isPositiveChange ? <PiArrowUpRight className={styles.arrowIcon} /> : <PiArrowDownRight className={styles.arrowIcon} />}
        </Box>
      </Box>
    </Box>
  );
};

CreatorDashboardListing.propTypes = {
  name: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  img: PropTypes.string.isRequired,
  nrOwners: PropTypes.number.isRequired,
  prChange: PropTypes.number.isRequired,
  price: PropTypes.number.isRequired,
};

export default CreatorDashboardListing;